import { UserRound } from "lucide-react";
import PageHero from "@/components/PageHero";
import PageLinkCTA from "@/components/PageLinkCTA";
import { Reveal, RevealText } from "@/components/Reveal";
import { BlueprintGrid } from "@/components/Backdrop";
import { COMPANY } from "@/data/company";

// Editable placeholder message — replace the paragraphs below with the final text.
const MESSAGE = [
  "At BIK COMMOTRADE (OPC) PVT LTD, our approach is rooted in a simple belief — that railway applications demand components engineered with care, manufactured with discipline and delivered with consistency.",
  "We focus on quality, reliability and the practical requirements of our customers. Every product we manufacture or supply is treated as a reflection of our commitment to the railway ecosystem we serve.",
  "We place strong emphasis on continuous improvement — refining our processes, our precision and our understanding of customer requirements with every engagement.",
  "We value long-term business relationships built on trust, transparency and dependable delivery. Thank you for considering us as your engineering partner.",
];

export default function DirectorMessage() {
  const { director } = COMPANY;
  return (
    <>
      <PageHero
        eyebrow="Leadership"
        title="Director's Message"
        description="A word from the leadership of BIK COMMOTRADE (OPC) PVT LTD."
      />

      <section className="relative overflow-hidden bg-[#F3F7FB] pb-24" data-testid="director-section">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(40%_50%_at_20%_30%,rgba(16,185,129,0.09),transparent_70%)]"
        />
        <div className="wrap relative grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
          {/* Portrait + signature placeholders */}
          <Reveal className="relative">
            <div className="relative overflow-hidden rounded-3xl border border-navy-900/10 bg-white shadow-[0_30px_80px_rgba(5,11,24,0.6)]">
              <div className="relative aspect-[3/4]">
                {director.portrait.src ? (
                  <img src={director.portrait.src} alt={director.portrait.alt} className="h-full w-full object-cover" />
                ) : (
                  <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-8 text-center">
                    <div className="absolute inset-0 blueprint-grid opacity-60" aria-hidden="true" />
                    <span className="relative flex h-24 w-24 items-center justify-center rounded-full border border-dashed border-brand-emeraldLight/50 bg-slate-100">
                      <UserRound className="h-11 w-11 text-brand-emeraldDark" />
                    </span>
                    <p className="relative font-mono text-[10px] uppercase tracking-[0.28em] text-brand-emeraldDark">
                      Portrait Placeholder
                    </p>
                    <p className="relative text-xs text-slate-500">Director's photograph will be uploaded here</p>
                  </div>
                )}
              </div>
              <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-brand-emerald via-brand-blueGlow to-brand-emerald" />
              <div className="relative flex items-center justify-between border-t border-navy-900/[0.08] bg-white/80 px-6 py-5">
                <div>
                  <p className="font-display text-xl font-bold uppercase tracking-wide text-ink">{director.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-slate-500">{director.role}</p>
                </div>
                <span className="chip">BIK</span>
              </div>
            </div>
          </Reveal>

          {/* Message */}
          <div className="flex flex-col justify-center">
            <Reveal>
              <span className="eyebrow">A Commitment to Engineering</span>
            </Reveal>
            <RevealText
              text="Engineering with Purpose. Manufacturing with Precision."
              as="h2"
              className="mt-5 font-display text-3xl font-bold uppercase leading-tight tracking-tight text-ink sm:text-4xl"
            />
            <div className="mt-8 space-y-5">
              {MESSAGE.map((para, i) => (
                <Reveal key={i} delay={0.1 + i * 0.08}>
                  <p className="leading-relaxed text-slate-600">{para}</p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.45}>
              <div className="mt-10 border-l-2 border-brand-emerald pl-6">
                <p className="font-display text-2xl font-bold uppercase tracking-wide text-ink">{director.name}</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.26em] text-brand-emeraldDark">
                  {director.role} — {COMPANY.shortName}
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="wrap section-pad">
        <PageLinkCTA />
      </section>
    </>
  );
}
